<template>
    <aside>
        <div class="section-data" style="min-height: 400px;">
            <div class="title d-flex justify-content-between">
                <div class="text">
                    <div id="slot-title">
                    </div>
                    <h3 class="font-blue">Detalles del curso</h3>
                    <p class="font-gray-dark">Ingresa la información correspondiente para continuar.</p>
                </div>
                <div class="tools">
                    <div id="slot-tools">
                    </div>
                </div>
            </div>
            <div class="data">
                <div class="container my-3">
                    <div id="slot-content">
                    </div>
                    <div class="content">

                        <div class="target-downloading text-center p-1 font-gray-dark" v-if="downloading">
                            <b-spinner small label="Espere ..."></b-spinner>
                            <span class="p-1">Espere un momento...</span>
                        </div>

                        <div class="target-body pb-5" v-show="!downloading">
                            <div class="alert alert-warning" role="alert" v-if="form.validate_column.comment">
                                <h3><h3 class="fas fa-info-circle"></h3> Actualiza la información</h3>
                                <p class="text-left pt-2">
                                    Actualizar los campos con el ícono <i class="fa fa-exclamation-triangle"
                                                                          aria-hidden="true"/>.<br>
                                    Toma en cuenta el siguiente comentario de nuestro equipo: <br>
                                    <b>
                                        {{ form.validate_column.comment }}
                                    </b>
                                </p>
                            </div>

                            <div class="cursepreview mb-5">

                                <h5 class="font-gray-dark">Así mostraremos tu curso al público.</h5>
                                <p class="text-left font-gray-dark">
                                    Este será el formato público, asegúrate de respetar los márgenes y cumplir con los
                                    requerimientos de publicación.
                                </p>

                                <b-card no-body class="overflow-hidden" style="border: 1px solid rgb(36 65 118);">
                                    <b-row no-gutters>
                                        <b-col sm="12" md="12" lg="4" xl="4" class="p-4">
                                            <b-card-img v-if="previewCover"
                                                        :src="previewCover"
                                                        class="rounded card-img">
                                            </b-card-img>
                                            <img v-else src="@/assets/banners/curses/banner-curse-default.jpg" alt=""
                                                 class="rounded card-img">
                                        </b-col>
                                        <b-col sm="12" md="12" lg="8" xl="8">
                                            <h4 class="font-blue text-left">
                                                {{ form.title == null ? 'Ingresa un nombre de curso' : form.title }}
                                            </h4>
                                            <hr>  
                                            <div class="testClass">
                                              <p align="justify">{{ form.description }}</p> 
                                            </div>
                                            <br> 
                                        </b-col>
                                    </b-row>
                                </b-card>

                                <div class="__errorcover text-danger">
                                    <small>{{ errors.cover ? errors.cover[0] : '' }}</small>
                                </div>
                                <label class="btn b-gray-light bh-cursor mt-2"
                                       v-b-tooltip.hover
                                       title="Seleccionar una portada de tu equipo">
                                    <i class="fas fa-photo-video"></i> Cambiar Portada
                                    <input type="file" hidden ref="file" @change="handleFileUpload">
                                </label>
                                <label class="font-orange" v-if="warning.cover">
                                    <i class="fa fa-exclamation-triangle font-orange text-center" aria-hidden="true"/>
                                    Debe cambiar la portada
                                </label>

                            </div>

                            <b-form-group>
                                <label>
                                    <i class="fa fa-exclamation-triangle font-orange" aria-hidden="true"
                                       v-if="warning.title"/>
                                    Nombre del curso
                                </label>
                                <b-form-input :class="{'border-warning':warning.title}"
                                              v-model="form.title" type="text" required
                                              placeholder="Ej. Aprender a leer fácilmente">
                                </b-form-input>
                                <b-form-invalid-feedback :state="false" v-if="errors.title">
                                    El campo título debe tener al menos 10 caracteres.
                                </b-form-invalid-feedback>
                            </b-form-group>


                            <b-form-group>
                                <label>
                                    <i class="fa fa-exclamation-triangle font-orange" aria-hidden="true"
                                       v-if="warning.description"/>
                                    Descripción
                                </label>
                                <b-form-textarea
                                        :class="{'border-warning':warning.description}"
                                        v-model="form.description"
                                        required
                                        placeholder="Descripción del curso (max. 1500 caracteres)."
                                        rows="3"
                                        max-rows="6">
                                </b-form-textarea>
                                <b-form-invalid-feedback :state="false" v-if="errors.description">
                                    El campo descripción debe tener máximo 500 caracteres.
                                </b-form-invalid-feedback>
                            </b-form-group>


                            <b-form-group>
                                <label>
                                    <i class="fa fa-exclamation-triangle font-orange" aria-hidden="true"
                                       v-if="warning.location"/>
                                    Ubicación
                                </label>

                                <places
                                        :class="{'border-warning':warning.location}"
                                        class="form-control"
                                        placeholder="Ubicación"
                                        v-model="form.location"
                                        @change="val => { form.location = val }"
                                        :options="{ countries: [] }">
                                </places>

                                <b-form-invalid-feedback :state="false" v-if="errors.location">
                                    Ingresa una ubicación válida
                                </b-form-invalid-feedback>
                            </b-form-group>


                            <b-form-group>
                                <label>
                                    <i class="fa fa-exclamation-triangle font-orange" aria-hidden="true"
                                       v-if="warning.category"/>
                                    Categoría
                                </label>
                                <select @change="form.category = categoriaSelect== 0 ?  '' : categoriaSelect"
                                        v-model="categoriaSelect"
                                        class="form-control"
                                        :class="{'border-warning':warning.category}">
                                    <option :value="''" disabled>Seleccionar una opción</option>
                                    <option :value="c.id" v-for="c in categorias">{{ c.value }}</option>
                                    <option :value="0">Otra categoría</option>
                                </select>
                                <b-form-input class="mt-2" v-if="categoriaSelect === 0" v-model="form.category"
                                              type="text" required
                                              placeholder="Categoría">
                                </b-form-input>
                                <b-form-invalid-feedback :state="false" v-if="errors.category">
                                    El campo categoría es requerido
                                </b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group>
                                <label> 
                                    Tipo
                                </label>
                                <select  v-model="form.tipo"   class="form-control">
                                    <option :value="null" disabled>Seleccionar una opción</option> 
                                    <option value="Presencial">Presencial</option>
                                    <option value="Virtual">Virtual</option>
                                </select> 
                                <b-form-invalid-feedback :state="false" v-if="errors.tipo">
                                    El campo categoría es requerido
                                </b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group v-if="form.tipo == 'Virtual'">
                                <label> 
                                   Medio
                                </label>
                                <select @change="form.medio = medioSelect == 0 ?  '' : medioSelect" v-model="medioSelect" class="form-control" >
                                    <option :value="null" disabled>Selecciona una opción</option> 
                                    <option value="Skype">Skype</option>
                                    <option value="Zoom">Zoom</option>
                                    <option value="Google Meets">Google Meets</option>
                                    <option value="Microsoft Teams">Microsoft Teams</option>
                                    <option :value="0">Otro</option>
                                </select>
                                <b-form-input class="mt-2" v-if="medioSelect == 0" v-model="form.medio"
                                              type="text" required
                                              placeholder="Otro medio">
                                </b-form-input>
                                <!-- <b-form-invalid-feedback :state="false" v-if="errors.medio">
                                    El campo lenguaje es requerido
                                </b-form-invalid-feedback> -->
                            </b-form-group>



                            <b-form-group>
                                <label>
                                    <i class="fa fa-exclamation-triangle font-orange" aria-hidden="true"
                                       v-if="warning.lenguage"/>
                                    Idioma del curso
                                </label>
                                <select  v-model="lenguajeSelect" class="form-control"
                                        :class="{'border-warning':warning.lenguage}">
                                    <option :value="''" disabled>Selecciona una opción</option>
                                    <option :value="l.id" v-for="l in idiomas">{{ l.name }}</option>
                                    <option value="0">Otro idioma</option>
                                </select>
                                <b-form-input class="mt-2" v-if="lenguajeSelect == '0'" v-model="form.lenguage"
                                              type="text" required
                                              placeholder="Idioma">
                                </b-form-input>
                                <b-form-invalid-feedback :state="false" v-if="errors.lenguage">
                                    El campo lenguaje es requerido
                                </b-form-invalid-feedback>
                            </b-form-group>

            
                            <b-form-group>
                                <label>
                                   ¿Este curso tiene cupo ilimitado?
                                </label>
                                <b-form-radio-group
                                    v-model="selected2"
                                    :options="options"
                                    class="mb-3"
                                    value-field="item"
                                    text-field="name"
                                    disabled-field="notEnabled"
                                    size="lg"
                                    @change="form.quota = 0 "
                                ></b-form-radio-group>  
                            </b-form-group>

                            <b-form-group v-if="selected2 == 'No'">
                                <label>
                                    <i class="fa fa-exclamation-triangle font-orange" aria-hidden="true"
                                       v-if="warning.quota"/>
                                    Cupo
                                </label>
                                <b-form-input :class="{'border-warning':warning.quota}"
                                              v-model="form.quota" type="text" required
                                              placeholder="Ingresa el cupo de personas">
                                </b-form-input>
                                <b-form-invalid-feedback :state="false"  v-if="errors2.includes( 'cuota' )">
                                    Debes ingresar un numero de personas
                                </b-form-invalid-feedback>
                            </b-form-group>


                            <b-form-group>
                                <label>
                                    <i class="fa fa-exclamation-triangle font-orange" aria-hidden="true"
                                       v-if="warning.duration"/>
                                    Duración
                                </label>
                                <b-form-input
                                        :class="{'border-warning':warning.duration}"
                                        v-model="form.duration" type="text" step=".01" required
                                        placeholder="Ingresa la duración del curso. Ej 12 semanas">
                                </b-form-input>
                                <b-form-invalid-feedback :state="false" v-if="errors.duration">
                                    Debes ingresar un la duración
                                </b-form-invalid-feedback>
                            </b-form-group>

                            <div>
                                <b-row>
                                    <b-col>
                                        <label>Periodo</label>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col  md="4" sm="12">
                                        <b-form-group>
                                            <label>
                                                <i class="fa fa-exclamation-triangle font-orange" aria-hidden="true"
                                                   v-if="warning.date_start"/>
                                                Inicia:
                                            </label>
                                            <!-- <Datepicker
                                                    v-model="form.date_start"
                                                    :input-class="{'form-control':!warning.date_start, 'form-control border-warning':warning.date_start}"
                                                    :language="es"></Datepicker> -->
                                            <input type="date" :min="exh" class="form-control" v-model="form.date_start">
                                            <b-form-invalid-feedback :state="false" v-if="errors.date_start">
                                                Debes ingresar una fecha
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                    <b-col  md="4" sm="12">
                                        <b-form-group>
                                            <label>
                                                <i class="fa fa-exclamation-triangle font-orange" aria-hidden="true"
                                                   v-if="warning.date_end"/>
                                                Termina:
                                            </label>
                                            <!-- <Datepicker
                                                    v-model="form.date_end"
                                                    :input-class="{'form-control':!warning.date_end, 'form-control border-warning':warning.date_end}"
                                                    :language="es"></Datepicker> -->
                                            <input type="date" :min="exh" class="form-control" v-model="form.date_end">
                                            <b-form-invalid-feedback :state="false" v-if="errors.date_end">
                                                Debes ingresar una fecha
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                    <b-col  md="4" sm="12">
                                        <b-form-group>
                                            <label>
                                               Fecha Fin de Publicación
                                            </label>
                                            <input type="date" :min="exh" class="form-control" v-model="form.fecha_fin">
                                            <!-- <Datepicker  v-model="form.fecha_fin" input-class="form-control" :language="es" minDate="2024-02-15"></Datepicker> -->
                                            <b-form-invalid-feedback :state="false" v-if="errors.fecha_fin">
                                                Debes ingresar una fecha
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </div>

                            <div>
                                <b-row>
                                    <b-col>
                                        <label>Horario (Formato 24 horas)</label>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <b-form-group>
                                            <label>
                                                <i class="fa fa-exclamation-triangle font-orange" aria-hidden="true"
                                                   v-if="warning.time_start"/>
                                                De:
                                            </label>
                                            <vue-timepicker
                                                    input-class="form-control"
                                                    :input-class="{'border-warning':warning.time_start}"
                                                    input-width="100%"
                                                    v-model="form.time_start"
                                                    format="HH:mm"></vue-timepicker>
                                            <b-form-invalid-feedback :state="false" v-if="errors.time_start">
                                                Debes ingresar una hora
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group>
                                            <label>
                                                <i class="fa fa-exclamation-triangle font-orange" aria-hidden="true"
                                                   v-if="warning.time_end"/>
                                                A:
                                            </label>
                                            <vue-timepicker
                                                    input-class="form-control"
                                                    :input-class="{'border-warning':warning.time_end}"
                                                    input-width="100%"
                                                    v-model="form.time_end"
                                                    format="HH:mm"></vue-timepicker>
                                            <b-form-invalid-feedback :state="false" v-if="errors.time_end">
                                                Debes ingresar una hora
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </div>


                            <b-form-group>
                                <label>
                                    <i class="fa fa-exclamation-triangle font-orange" aria-hidden="true"
                                       v-if="warning.certification"/>
                                    Constancia
                                </label>
                                <select  class="form-control"  v-model="form.certification">
                                    <option :value="''" disabled>Selecciona</option> 
                                    <option value="Certificado">Certificado</option>
                                    <option value="Diploma">Diploma</option>
                                    <option value="Reconocimiento">Reconocimiento</option> 
                                </select>
                                <!-- <b-form-input :class="{'border-warning':warning.certification}"
                                              v-model="form.certification" type="text"
                                              placeholder="Ej. Diploma, Reconocimiento">
                                </b-form-input> -->
                                <b-form-invalid-feedback :state="false" v-if="errors.certification">
                                    Debes ingresar una Constancia
                                </b-form-invalid-feedback>
                            </b-form-group>

                            
                            <b-form-group>
                                <label>
                                   ¿Este curso tendrá algún costo?
                                </label>
                                <b-form-radio-group
                                    v-model="selected"
                                    :options="options"
                                    class="mb-3"
                                    value-field="item"
                                    text-field="name"
                                    disabled-field="notEnabled"
                                    size="lg"
                                    @change="form.price = null, selected3 = 'No'"
                                ></b-form-radio-group>  
                            </b-form-group>

                            <b-form-group v-if="selected == 'Si'">
                                <label>
                                   ¿Este curso tendrá alguna promoción?
                                </label>
                                <b-form-radio-group
                                    v-model="selected3"
                                    :options="options"
                                    class="mb-3"
                                    value-field="item"
                                    text-field="name"
                                    disabled-field="notEnabled"
                                    size="lg"
                                ></b-form-radio-group>  
                            </b-form-group>

                                           
                            <b-form-group v-if="selected3 == 'Si'">
                                <label>
                                   ¿Deseas agregar cupón de descuento/promoción exclusivo para usuarios de la plataforma Kllaar.com?
                                </label>
                                <b-form-radio-group
                                    v-model="selected4"
                                    :options="options"
                                    class="mb-3"
                                    value-field="item"
                                    text-field="name"
                                    disabled-field="notEnabled"
                                    size="lg"
                                ></b-form-radio-group>  

                                <hr>

                                    <div class="row justify-content-center" v-if="selected4 == 'Si'">

                                        <div class="col-md-4">
                                            <label>
                                              Porcentaje descuento
                                            </label>
                                            <select  class="form-control"  v-model="descuento"  :class="{'border-warning':warning.descuento}">
                                                <option :value="null" disabled>Selecciona</option> 
                                                <option value="5">5%</option>
                                                <option value="10">10%</option>
                                                <option value="15">15%</option>
                                                <option value="20">20%</option>
                                                <option :value="0">Otro</option>
                                            </select>
                                            <b-form-input class="mt-2" v-if="descuento == 0" v-model="descuento_otro"
                                              type="number" step=".01" required
                                              placeholder="Otro porcentaje"></b-form-input>
                                            <b-form-invalid-feedback :state="false" v-if="errors2.includes( 'descuento' )">
                                               Vigencia del cupón de descuento es requerido
                                            </b-form-invalid-feedback>
                                        </div>
                                        <div class="col-md-4">
                                            <label>
                                               Agregar vigencia
                                            </label>
                                             <input type="date" v-model="fecha_descuento" :min="exh" :max="form.date_end" class="form-control" >
                                            <b-form-invalid-feedback :state="false" v-if="errors2.includes( 'fecha_descuento' )">
                                               Vigencia del cupón de descuento es requerido
                                            </b-form-invalid-feedback>
                                        </div>
                                        <div class="col-md-4"></div> 
                                    </div>

                                                  
                                    <!-- <b-button type="button" class="shadow b-orange mt-2" v-if="selected4 == 'Si'">
                                        Agregar Cupón
                                    </b-button> -->

                                <p v-if="selected4 == 'No'" class="mt-4">Sí deseas agregar una promoción diferente a tu curso <u class="font-orange" style="cursor: pointer;" @click="contacto()">contáctanos</u></p>

                                <hr>

                            </b-form-group>
 
 
                            <b-form-group v-if="selected == 'Si'">
                                <label>
                                    <i class="fa fa-exclamation-triangle font-orange" aria-hidden="true"
                                       v-if="warning.price"/>
                                    Precio del curso  (MXN)
                                </label>
                                <b-form-input :class="{'border-warning':warning.price}"
                                              v-model="form.price" type="number" step=".01" required
                                              placeholder="Ej. 1299,00">
                                </b-form-input>
                                <b-form-invalid-feedback :state="false" v-if="errors2.includes( 'price' )">
                                    El precio del curso debe ser mínimo de 1.00 
                                </b-form-invalid-feedback>
                            </b-form-group>


                            <b-alert show variant="danger" v-show="validation.message">{{
                                    validation.message
                                }}
                            </b-alert>
                            
                            <b-button type="button" class="font-blue shadow bg-white" @click="previewValid">
                                <i class="fas fa-eye"></i>
                                Previsualizar
                            </b-button>

                            <b-button type="button" class="b-orange" :disabled="loading" @click="onSubmit">
                                <b-spinner v-if="loading" small label="Espere ..."></b-spinner>
                                {{ this.id ? 'Aplicar Cambios' : 'Iniciar Publicación' }}
                            </b-button>
                        </div>
                        <!--
                        <b-card class="mt-3" header="Form Data Result">
                          <pre class="m-0">{{ $data }}</pre>
                        </b-card>
                        -->


                        <!---Preview-->
                        <b-modal  title="Detalle del curso" hide-footer  v-model="preview" size="lg">  
                                <div class="row" style="background:  linear-gradient(to right,  #054fe5 0%, #2a4772  100%);  background-size: cover; color: #fff; " >
                                    <div class="col-lg-4 col-md-4 col-sm-12 mt-3">
                                        <img :src="previewCover ? previewCover : '@/assets/banners/curses/banner-curse-default.jpg'" alt="" height="200" class="shadow img-fluid">
                                        <div class="mt-3">
                                            <div>
                                                <small><i class="fas fa-map-marker-alt"></i> Ubicación</small>
                                                <b> {{ form.location }}</b>
                                            </div>
                                            <div class="mt-2">
                                                <small><i class="fas fa-users"></i> Cupo</small>
                                                  <b v-if="selected2 == 'No'">{{ form.quota }}</b>  
                                                  <b v-else>Ilimitado</b> 
                                            </div>
                                            <div class="mt-2">
                                                <small><i class="fas fa-stopwatch"></i> Duración del curso</small>
                                                <b> {{ form.duration }} </b>
                                            </div>
                                            <div class="mt-2" v-if="form.date_start">
                                                <small><i class="fas fa-calendar-day"></i> Inicio del curso</small>
                                                <b> {{ form.date_start  | date}} </b>
                                            </div>
                                            <div class="mt-2" v-if="form.date_end" >
                                                <small><i class="far fa-calendar"></i> Fin del curso</small>
                                                <b> {{ form.date_end  | date}} </b>
                                            </div>
                                            <div class="mt-2" v-if="form.time_start && form.time_end">
                                                <small><i class="fas fa-clock"></i> Horario</small>
                                               <b>{{ form.time_start  | horario }} - {{ form.time_end  | horario }}</b>
                                            </div>
                                            <div class="mt-2" >
                                                <small><i class="fas fa-file-contract"></i> Constancia</small>
                                                <b> {{ form.certification }}</b>
                                            </div> 
                                            <br>
                                        </div>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12  mt-3">
                                        <h3 data-purpose="lead-title">  {{ form.title == null ? 'Ingresa un nombre de curso' : form.title }}</h3>  
                                        <span>Precio del curso:
                                                 <b v-if="selected == 'Si'">${{ form.price }}</b>
                                                 <b v-else>Gratis</b> 
                                        </span>  
                                        <div v-for="cat in categorias" :key="cat.id" v-show="cat.id == form.category">
                                            Categoría: <b> {{cat.value}} </b> 
                                        </div>   
                                        <div v-for="ind in idiomas" :key="ind.id" v-show="ind.id == form.lenguage">
                                            Idioma: <b> {{ind.name}}</b> 
                                        </div>   
                                        <span v-if="descuento != null && selected == 'Si'"> <br>
                                            Porcentaje descuento: {{ descuento == '' ? descuento_otro : descuento }}% <br> Expira: {{ fecha_descuento}}
                                        </span> 
                                        <hr v-if="descuento != null && selected == 'Si'"> 
                                        <img v-if="descuento != null && selected == 'Si'" src="@/assets/cupon.png" alt="" width="180" class="shadow img-fluid"> 
                                        <hr>  
                                        <div   class="testClass">
                                            <p align="justify">{{ form.description }}</p> 
                                        </div>
                                        <br> 
                                    </div>
                                </div>  
                        </b-modal>
                        <!---./Preview-->
                    </div>
                </div>
            </div>
        </div>
    </aside>


</template>
<script>

import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import Datepicker from 'vuejs-datepicker';
import {es} from 'vuejs-datepicker/dist/locale'
import moment from "moment"

moment.locale('es');


export default {
    components: {
        VueTimepicker,
        Datepicker
    },
    props: {
        parentCurse: Object
    },
    data() {
        return {
            es: es, 
            id: null,
            downloading: false,
            categorias: [],
            categoriaSelect: '',
            idiomas: [],
            lenguajeSelect: "",
            medioSelect: null,
            previewCover: null,
            loading: false,
            form: {
                title: "",
                description: "",
                quota: 0,
                duration: null,
                category: null,
                tipo:"",
                medio:null,
                cover: null,
                time_start: null,
                time_end: null,
                date_start: null,
                date_end: null,
                fecha_fin: null,
                lenguage: "",
                location: null,
                certification: "",
                price: null,
                newCategory: false,
                newLenguage: false, 
                validate_column: {},
                status: null,
            },
            otherLenguage: '',
            errors: {},
            validation: {},
            warning: {},
            preview: false,
            selected:'Si',
            selected2:'No',
            selected3:'No',
            selected4:'Si',
            descuento:null,
            fecha_descuento:"",
            descuento_otro:"",
            options: [
                { item: 'Si', name: 'Si' },
                { item: 'No', name: 'No' } 
            ],
            exh:moment().format("YYYY-MM-DD"),
            edit:0,
            errors2:[],
            isMobile: this.$mobile(), 
        }
    }, 
    methods: {
        previewValid() {
            if (this.form.title) {
                this.preview = true
            } else {
                swal('Vista previa no disponible', 'Es importante llenar los datos del formulario para poder tener una vista previa', 'warning')
            }
        },
        handleFileUpload(e) {
            this.form.cover = e.target.files[0]
            this.previewCover = URL.createObjectURL(this.form.cover);
        },
        onSubmit() {

            if (this.categoriaSelect !== 0) {
                this.form.category = this.categoriaSelect;
                this.form.newCategory = false
            } else {
                this.form.newCategory = true
            }

             if (this.lenguajeSelect !== 0) {
                this.form.lenguage = this.lenguajeSelect;
                this.form.newLenguage = false
            } else {
                this.form.newLenguage = true
            }

            if (this.medioSelect !== 0) {
                this.form.medio = this.medioSelect; 
            } 

            const fd = new FormData()

            var d1 = moment(this.form.date_start).format("YYYY-MM-DD")
            var d2 = moment(this.form.date_end).format("YYYY-MM-DD")
            var d3 = moment(this.form.fecha_fin).format("YYYY-MM-DD")

             var desc = this.descuento == 0 ? this.descuento_otro : this.descuento;

            fd.append('title', this.form.title)
            fd.append('description', this.form.description)
            fd.append('lenguage', this.form.lenguage)
            fd.append('category', this.form.category)
            fd.append('tipo', this.form.tipo)
            fd.append('medio', this.form.medio)
            fd.append('price', this.form.price)
            fd.append('price_val', this.selected)
            fd.append('quota', this.form.quota)
            fd.append('duration', this.form.duration ? this.form.duration : "")
            fd.append('time_start', this.form.time_start.HH + ":" + this.form.time_start.mm)
            fd.append('time_end', this.form.time_end.HH + ":" + this.form.time_end.mm )
            fd.append('date_start', d1)
            fd.append('date_end', d2)
            fd.append('fecha_fin', d3)
            fd.append('location', this.form.location ? this.form.location : "")
            fd.append('certification', this.form.certification)
            fd.append('newCategory', this.form.newCategory)
            fd.append('newLenguage', this.form.newLenguage)
            fd.append('status', this.form.status)
            fd.append('cover', this.form.cover ? this.form.cover : null)
            fd.append('ilimitado', this.selected2)
            fd.append('promocion', this.selected3) 
            fd.append('descuento', desc)
            fd.append('fecha_descuento', this.fecha_descuento)
            this.loading = true

            // if (this.id) {
                fd.append('published', false)
                fd.append('active', false)
                fd.append('status', "review")
                fd.append('historial', 0) 
                
                this.update(fd)
            // } else {
            //     this.insert(fd)
            // }
        },
        update(fd) {
            this.errors = {}
            this.errors2 = []
            if (this.selected2 == 'No' && this.form.quota == 0 || this.selected2 == 'No' && !this.form.quota)
            {
               this.errors2.push('cuota'); 
               this.loading = false
            }if (this.selected == 'Si' && !this.form.price)
            {
               this.errors2.push('price'); 
               this.loading = false
            }if (this.selected3 == 'Si' && this.selected4 == 'Si' && this.descuento == null)
            {
               this.errors2.push('descuento'); 
               this.loading = false
            }if (this.selected3 == 'Si' && this.selected4 == 'Si' && !this.fecha_descuento)
            {
               this.errors2.push('fecha_descuento'); 
               this.loading = false
            }if (this.errors2.length == 0) { 
                this.api.post('course/duplicar/' + this.id, fd).then(({data}) => {
                    console.log(data)
                    this.toast("Se ha actualizado correctamente tu cursp", true)
                    setTimeout(() => {
                    this.$router.push('/perfil/cursos')
                    }, 300) 
                    this.$parent.loadCurseFromId(this.id)
                    this.loading = false
                    this.validation = {}
                    this.warning = {}
                    this.form.validate_column.comment = null
                }).catch(err => {
                    this.loading = false
                     this.errors = err.response.data.errors
                      this.toast("Valida campos obligatorios", false)
                })
            }else{
                 this.toast("Valida campos obligatorios", false)
            }
        },
        insert(fd) {
            this.errors = {}
            this.api.post('course/create', fd).then(({data}) => {
                console.log(data)
                 this.toast("Se ha registrado correctamente tu curso", true)
                setTimeout(() => {
                    this.$router.push('/curse/generateactive/' + data.data.id + '/content')
                   }, 300) 
                // this.$router.go()
                this.loading = false

            }).catch(err => {
                this.loading = false
                // if (err.response.status == 403) {
                    this.errors = err.response.data.errors
                // } else if (err.response.status == 404) {
                //     this.validation = err.response.data
                // }
            })
        },
        toast(message, isSuccess) {

            if (isSuccess) {

                this.$bvToast.toast(message, {
                    title: "Kllaar.com",
                    variant: 'success',
                    toaster: 'b-toaster-bottom-right',
                    solid: true,
                    appendToast: true
                })

            } else {

                this.$bvToast.toast(message, {
                    title: "Kllaar.com",
                    variant: 'danger',
                    toaster: 'b-toaster-bottom-right',
                    solid: true,
                    appendToast: true
                })

            }
        },
        contacto(){
          location.href = '/atencion-clientes';
        }
    },
    created() {
        //get elementID
        let id = this.$route.params.id


        if (id != undefined) {
            this.id = id
            this.downloading = true
            this.api.get('course/' + id).then(({data}) => {

                this.form.title = data.data.title
                this.form.description = data.data.description
                this.form.tipo = data.data.tipo;
                this.form.category = data.data.category_id
                this.categoriaSelect = data.data.category_id
                this.form.lenguage = data.data.lenguage_id
                this.form.price = data.data.price
                this.selected = data.data.price_val
                this.form.location = data.data.location 
                this.form.duration = data.data.duration
                this.form.quota = data.data.quota
                this.form.certification = data.data.certification
                this.previewCover = data.data.cover
                this.form.status = data.data.status

                this.medioSelect = data.data.medio == 'Skype' || data.data.medio == 'Zoom' || data.data.medio == 'Google Meets' || data.data.medio == 'Microsoft Teams' ? data.data.medio : 0;
                if (this.medioSelect == 0) {
                    this.form.medio = data.data.medio
                }

                if (data.data.validate_column) {
                    this.form.validate_column = JSON.parse(data.data.validate_column)
                    this.warning = JSON.parse(data.data.validate_column)
                }

                this.lenguajeSelect = data.data.lenguage_id
                this.selected2 = data.data.ilimitado

                this.descuento = null;
                this.fecha_descuento = "";

                // this.selected3 = data.data.promocion

                // if (data.data.descuento != 5 && data.data.descuento != 10 && data.data.descuento != 15 && data.data.descuento != 20)
                // {
                //     this.descuento = 0;
                //     this.descuento_otro = data.data.descuento;
                // } else{
                //     this.descuento = data.data.descuento;
                //     this.descuento_otro = "";
                // }
                // this.fecha_descuento = data.data.fecha_descuento

                this.downloading = false
            }).catch(err => {
                this.downloading = false
            })
        }else{
            this.lenguajeSelect = "";
            this.form = {
                title: "",
                description: "",
                quota: 0,
                duration: null,
                category: null,
                tipo:"",
                medio:null,
                cover: null,
                time_start: null,
                time_end: null,
                date_start: null,
                date_end: null,
                fecha_fin: null,
                lenguage: "",
                location: null,
                certification: "",
                price: null,
                newCategory: false,
                newLenguage: false, 
                validate_column: {},
                status: null,
            }
         

        }

        this.api.get('module/lenguages').then(({data}) => {
            this.idiomas = data.data
        })

        this.api.get('module/work_area_id').then(({data}) => {
            this.categorias = data.data
            this.$forceUpdate()
        })

        // this.$bus.$on("activa-curso", () => {
        //      this.edit = 1; 
        // })
    },
    filters: {
      date(val) {
        moment.locale('es');
        return moment(val).format("DD [de] MMMM [del] YYYY ")
      },
      horario(val) { 
        return val ? val.HH + ":" + val.mm + " horas" : false
      }
    }
}
</script>

<style lang="scss">
//.target {
//  margin-top: 0;
//}

.section {
  &-data {
    background: #fff !important;
    -webkit-box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
    border-radius: .25rem !important;

    .title {
      padding: 15px 0 0 15px;
      border-bottom: 1px solid #EEEEEE;
    }

    .data {
      .is-empty, .is-loading {
        text-align: center;
        justify-content: center;
        align-content: center;

        img {
          opacity: .5;
        }
      }
    }
  }
}

.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}

.vdp-datepicker .form-control:disabled, .form-control[readonly] {
  background: white !important;
}

.testClass{
   white-space: -moz-pre-wrap; /* Mozilla, supported since 1999 */
    white-space: -pre-wrap; /* Opera */
    white-space: -o-pre-wrap; /* Opera */
    white-space: pre-wrap; /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
    word-wrap: break-word; /* IE 5.5+ */
}
</style>



// WEBPACK FOOTER //
// src/components/#pages/curses/pages/Name2.vue